var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptCloud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 103,
    viewBox: "0 0 156 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.235 53.9791C133.452 52.8753 133.569 51.7338 133.569 50.5636C133.569 40.9686 125.852 33.1911 116.332 33.1911C115.111 33.1911 113.922 33.3219 112.774 33.5657C112.807 32.9695 112.827 32.3688 112.827 31.766C112.829 14.2229 98.7169 0 81.3086 0C67.5244 0 55.8162 8.92116 51.5345 21.3443C48.1786 19.3406 44.2642 18.1881 40.0814 18.1881C27.6497 18.1881 17.5733 28.3438 17.5733 40.8733C17.5733 44.2534 18.3122 47.4561 19.6273 50.3375C8.32152 53.4294 0 63.8334 0 76.1966C0 90.9891 11.9105 103 26.5941 103H147.01C152.545 97.767 156 90.3331 156 82.0813C156 68.2064 146.223 56.6344 133.235 53.9791Z",
    fill: "url(#paint0_linear_1106_637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1106_637",
    x1: 78,
    y1: 0,
    x2: 78,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391559",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptCloud2);
export default __webpack_public_path__ + "static/media/prompt-cloud-2.52f8ddb7311696b2e50a5d5b5b76c3ea.svg";
export { ForwardRef as ReactComponent };